<template>
    <div>
        <v-radio-group v-model="commissionForEdit.commissionType" inline>
            <v-radio
                v-for="item in commissionTypeItems"
                :key="item.value"
                class="me-2"
                :value="item.value"
                :label="item.label"
            />
        </v-radio-group>
        <v-row v-for="(component, i) in commissionAmountComponentItems" :key="i" align="center">
            <v-col cols="6" md="4">
                {{ component.prependText }}
            </v-col>
            <v-col cols="6" md="8">
                <NumberInputWithButtons
                    v-model="commissionForEdit[component.valueField]"
                    :label="commissionForEdit[component.typeField] === 'PERCENTAGE' ? $t('percent') : $t('amount')"
                    :width="180"
                    class="mb-2"
                    :buttons="[
                        {
                            icon: 'mdi-percent',
                            active: commissionForEdit[component.typeField] === 'PERCENTAGE',
                            onClick: () => (commissionForEdit[component.typeField] = 'PERCENTAGE'),
                        },
                        {
                            icon: 'mdi-cash',
                            active: commissionForEdit[component.typeField] === 'ABSOLUTE',
                            onClick: () => (commissionForEdit[component.typeField] = 'ABSOLUTE'),
                        },
                    ]"
                    :append-text="
                        commissionForEdit[component.typeField] === 'ABSOLUTE' ? commissionForEdit.currencyCode : null
                    "
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" md="4"> <div class="d-flex align-center justify-end full-height full-width">+</div></v-col>
            <v-col cols="6" md="8">
                <NumberInputWithButtons
                    v-model="commissionForEdit.serviceCommissionValue"
                    :label="$t('amount')"
                    :width="180"
                    :buttons="[]"
                    class="mb-2"
                    :append-text="`${commissionForEdit.currencyCode} ${t('commission_for_the_service')}`"
                />
            </v-col>
        </v-row>
    </div>
</template>
<script setup lang="ts">
    const {t} = useI18n()

    const commissionForEdit = defineModel()

    watch(
        () => commissionForEdit.value.commissionType,
        () => {
            if (commissionForEdit.value.commissionType !== 'ACCOMMODATION') {
                delete commissionForEdit.value.mealCommissionType
                delete commissionForEdit.value.mealCommissionValue
            } else {
                commissionForEdit.value.mealCommissionValue = 0
                commissionForEdit.value.mealCommissionType = 'PERCENTAGE'
            }
        }
    )

    const commissionTypeItems = computed(() => [
        {
            label: t('serviceType.ACCOMMODATION'),
            value: 'ACCOMMODATION',
        },
        {
            label: t('service'),
            value: 'TRIP',
        },
    ])

    const commissionAmountComponentItems = computed(() => {
        const items = [
            {
                valueField: 'baseCommissionValue',
                typeField: 'baseCommissionType',
                prependText: t('commission_per_base'),
            },
            {
                valueField: 'extrabedCommissionValue',
                typeField: 'extrabedCommissionType',
                prependText: t('commission_per_extra_bed'),
            },
            {
                valueField: 'sharingCommissionValue',
                typeField: 'sharingCommissionType',
                prependText: t('commission_per_sharing'),
            },
        ]

        if (commissionForEdit.value.commissionType === 'ACCOMMODATION') {
            items.push({
                valueField: 'mealCommissionValue',
                typeField: 'mealCommissionType',
                prependText: t('commission_per_meal'),
            })
        }

        return items

        // "serviceCommissionType": "",
        //   "serviceCommissionValue": 0,
    })
</script>
